<template>
    <div data-spm="select" v-if="fields&&canShow" class="vote-c">
        <!-- 未开始|审核未通过|驳回 -->
        <UnStart v-if="!isStart"/> 
        <div data-spm-type="resource" v-else data-spm-content="">
            <TextVote v-if="isText" :fields="fields" @sendVote="handelSendVote"/>
            <PictureVote v-if="isPicture" :fields="fields" @sendVote="handelSendVote"/>
            <CancleModal v-if="showCancleModal" @closeCancleModal="closeCancleModal"/>
        </div>
    </div>
</template>
<script>
import PictureVote from './picture-vote.vue'
import TextVote from './text-vote.vue'
import UnStart from './un-start.vue'
import CancleModal from './cancleModal.vue'
import { sendVote,getDiscussInfoById,cancelVote } from '../../../../_utils/request'
import CookieUtil from '../../../../_utils/cookie';
import LocalStorageUtil from '../../../../_utils/localstorageUtil'

const spm = window.sohuSpm?.getCodes()

export default {
    components: {
        PictureVote,
        TextVote,
        UnStart,
        CancleModal
    },
    data() {
        return {
            voteData: {},
            isLogin: false, // 是否已经登录
            showCancleModal: false
        }
    },
    computed: {
        fields() {
            return this.voteData?.fields
        },
        cardType() {
            return this.fields?.optionType
        },
        // 文字类型讨论
        isText() {
            return this.cardType == 0
        },
        // 图片类型讨论
        isPicture() {
            return this.cardType == 1
        },
        // 删除&下线不展示 3&6
        canShow() {
            return this.voteData?.status != 3 && this.voteData?.status != 6
        },
        // 1-通过 5-历史
        isAudit() {
            return this.voteData?.status != 1 && this.voteData?.status != 5
        },
        // 未开始
        isStart() {
            if(this.isAudit) return false
            if(this.fields?.startTime && new Date().getTime() < this.fields?.startTime) {
                return false
            }
            return true
        },
        // 已结束
        isFinish() {
            return this.fields?.endTime ? new Date().getTime() > this.fields?.endTime : false
        },
        // 投票选项
        voteId() {
            return this.fields?.userOptionId || ''
        },
        // 已投票
        isVoted() {
            return this.fields?.userOptionId || false
        },
    },
    mounted() {
        this.voteData = this.articleData
        this.isLogin = !!window.userInfo?.userId
        this.handleCache() //处理缓存
        this.$nextTick(()=>{
            window.sohuSpm?.domDidChange({target:'select'})
        })
    },
    methods: {
        handleCache() {
            // 已登录&未投票&缓存有记录
            const voteCacheId = LocalStorageUtil.getItem(`vote_card_${this.fields?.voteId}`)
            if(this.isLogin && !this.isVoted && voteCacheId) {
                const oldOption = this.voteData.fields.options.find((item)=>{
                        return item.id == voteCacheId
                    })
                // 帮投
                this.handelSendVote(oldOption)
            }
        },
        // 发送投票
        async handelSendVote(item) {
            if(this.isFinish)return
            // 弹出取消弹窗
            if(this.voteId == item.id) {
                this.showCancleModal = true
                return
            }
            if(this.isVoted)return
            try {
                const p = {
                    topicTitle: this.fields?.title,
                    sourceId: "vt_" + this.fields?.voteId,
                    topicUrl: window.location.href,
                    attitudeGroupId: this.fields?.attitudeGroupId,
                    attitudeOptionId: item?.attitudeOptionId,
                    optionId: item?.id,
                    openId: CookieUtil.get("SUV") || '',
                    spma: "smwp",
                    spm: spm?.a + '.' + spm?.b + '.' + spm?.c,
                    requestId: CookieUtil.get("SUV") + '_' + new Date().getTime()
                }
                const res = await sendVote(p) // 发送投票
                if(res.code == 1) {
                    window?.sohuSpm?.sendAction({
                        acode: 9444,
                        clkParam: `optionType:${this.fields?.options?.length};voteId:${this.fields?.voteId};voteOptionId:${item?.attitudeOptionId};from: 6`
                    });
                    await this.getVoteInfo()
                }
            } catch (error) {
                console.log('投票error',error)
            }
        },
        // 获取投票状态
        async getVoteInfo() {
            let param = {
                voteIds: this.fields?.voteId,
                openId : CookieUtil.get("SUV") || '',
                spm : spm?.a + '.' + spm?.b + '.' + spm?.c,
                requestId: CookieUtil.get("SUV") + '_' + new Date().getTime(),
                templateType: 0,
            }
            const res = await getDiscussInfoById(param) // 获取当前投票数据
            if(res.code == 1) {
                const resData = res?.data?.[0] || {}
                if(this.voteData?.fields) {
                    this.voteData.fields = Object.assign(
                        {},
                        this.voteData.fields,
                        {
                            userOptionId: resData?.userOptionId,
                            options: resData?.options,
                        }
                    )
                }
                // 未登录，缓存投票结果
                if(!this.isLogin) {
                    if(resData?.userOptionId) {
                        LocalStorageUtil.setItem(`vote_card_${this.fields?.voteId}`,resData?.userOptionId)
                    }else {
                        LocalStorageUtil.removeItem(`vote_card_${this.fields?.voteId}`)
                    }
                }
            }
        },
        // 取消投票
        async closeCancleModal(flag) {
            this.showCancleModal = false
            if(flag) {
                window?.sohuSpm?.sendAction({
                    acode: 10884,
                    clkParam: `optionType:${this.fields?.options?.length};voteId:${this.fields?.voteId};voteOptionId:${this.voteId};from: 6`
                });
                // 发送取消
                const p = {
                    spm : spm?.a + '.' + spm?.b + '.' + spm?.c,
                    requestId: CookieUtil.get("SUV") + '_' + new Date().getTime(),
                    spma: spm?.a,
                    voteId: this.fields?.voteId,
                    beforeOptionId: this.fields?.userOptionId,
                    afterOptionId: '', // 取消投票操作，该值为null
                }
                const res = await cancelVote(p)
                if(res?.code == 1) {
                    await this.getVoteInfo()
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>

</style>